// Reine Datums-Helfer des SiGe-Plan-Moduls.
// Ausgelagert, damit Listen-Editor und KI-Übernahme dieselbe Klemm-Logik nutzen
// (vorher landeten KI-Schritte ungeklemmt in der Datenbank).

/** ISO-Datum (YYYY-MM-DD) auf Projektgrenzen klemmen — lexikalischer Vergleich genügt. */
export const clampDatum = (val?: string, von?: string, bis?: string): string => {
  if (!val) return '';
  if (von && val < von) return von;
  if (bis && val > bis) return bis;
  return val;
};

/** Phasen-Anteil (0..1) → echtes Datum innerhalb der Projektlaufzeit. */
export const phaseDatum = (frac: number, von?: string, bis?: string): string => {
  if (!von || !bis) return '';
  const a = new Date(von).getTime();
  const b = new Date(bis).getTime();
  if (isNaN(a) || isNaN(b) || b < a) return '';
  return new Date(a + frac * (b - a)).toISOString().split('T')[0];
};

/**
 * Nur echte ISO-Tagesdaten durchlassen. Die KI liefert auch „KW 12" oder
 * „März 2026" — solche Werte lösen beim Schreiben einen Cast-Fehler aus.
 */
export const alsIsoDatum = (val: unknown): string =>
  typeof val === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(val.trim()) ? val.trim() : '';
